import Loader from './loaders/loader';
class ProcessModel {
    constructor() {

    }
    static importGLTF(fileMap) {
        return Loader.importGLTF(fileMap)
    }
    static ensureModelUrl(item) {
        let url = null;
        if (item.model != null) url = item.model.path;
        return url;
    }
    /**
     * let Item = {
		model: {
			 path: URL_PATH,
			 type: model_type
		 }
	 };
     * @param {*} item 
     * @param {*} addScene 
     */
    static loadModel(item) {
        let url = ProcessModel.ensureModelUrl(item);
        if (url == null) {
            console.warn('the model url is null...');
            return;
        }
        return new Promise((resolve, reject) => {
            switch (item.model.type) {
                case 'fbx':
                    ProcessModel.loadFBXModel({
                        url
                    }).then(data => {
                        resolve(data);
                    });
                    break;
                case 'obj':
                    ProcessModel.loadObjectModel({
                        url
                    }).then(data => {
                        resolve(data);
                    });
                    break;
                case 'json':
                    ProcessModel.loadJSONModel({
                        url
                    }).then(data => {
                        resolve(data);
                    });
                    break;
                case 'gltf':
                    ProcessModel.loadGltfModel({
                        url
                    }).then(data => {
                        resolve(data);
                    });

                    break;

                case 'glb':
                    ProcessModel.loadGltfModel({
                        url
                    }).then(data => {
                        resolve(data);
                    });

                    break;
                default:
                    console.error("该模型格式尚不支持")
                    break;
            }
        });
    }
    static loadFBXModel(sceneInfo) {
        return new Promise((resolve, reject) => {
            try {
                Loader.loadFBXModel(sceneInfo).then(data => {
                    resolve(data);
                });
            } catch (error) {
                console.error("加载FBX模型出错");
                reject(error);
            }

        });
    }
    static loadGltfModel(sceneInfo) {
        return new Promise((resolve, reject) => {
            try {
                Loader.loadGltfModel(sceneInfo).then(data => {
                    resolve(data);
                });
            } catch (error) {
                console.error("加载Gltf模型出错");
                reject(error);
            }

        });
    }

    static loadJSONModel(sceneInfo) {
        return new Promise((resolve, reject) => {
            try {
                Loader.loadJSONModel(sceneInfo).then(data => {
                    resolve(data);
                });
            } catch (error) {
                console.error("加载JSON模型出错");
                reject(error);
            }

        });
    };

    static loadObjectModel(sceneInfo) {
        return new Promise((resolve, reject) => {
            try {
                Loader.loadObjectModel(sceneInfo).then(data => {
                    resolve(data);
                });
            } catch (error) {
                console.error("加载Object模型出错");
                reject(error);
            }

        });
    }
}
export default ProcessModel